import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  insights: { marginTop: "2.5em" },
  filterBar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: "1em",
    paddingTop: "1.5em",
    borderTop: "1px solid #E4E6EB",
  },
  filters: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "12px",
  },
  sectionTitle: { fontSize: "20px !important", fontWeight: "700 !important" },
  headText: {
    fontSize: "18px !important",
    fontWeight: "600 !important",
    marginTop: "1.5em !important",
  },
  message: {
    color: "#7E8184",
    fontSize: "14px !important",
    marginTop: "1em !important",
  },
  statCard: {
    backgroundColor: "#F6F7FB",
    borderRadius: "9px",
    padding: "1em",
    marginTop: "1em",
    height: "calc(100% - 1em)",
  },
  statLabel: {
    color: "#7E8184",
    fontSize: "13px !important",
    fontWeight: "500 !important",
  },
  statValue: {
    fontSize: "24px !important",
    fontWeight: "700 !important",
    margin: "0.2em 0 !important",
  },
  statHint: { color: "#7E8184", fontSize: "12px !important" },
  chartCard: {
    backgroundColor: "#F6F7FB",
    borderRadius: "9px",
    padding: "1em",
    marginTop: "1em",
  },
  chartTitle: { fontSize: "15px !important", fontWeight: "600 !important" },
  chartBody: { height: "220px", marginTop: "0.75em" },
  currencySelect: { minWidth: "140px !important", marginBottom: "8px !important" },
  tableCard: {
    backgroundColor: "#F6F7FB",
    borderRadius: "9px",
    padding: "1em",
    marginTop: "1em",
    overflow: "hidden",
  },
  tableHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "0.75em",
  },
  tableScroll: { overflowX: "auto", marginTop: "0.75em" },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    backgroundColor: "#fff",
    fontSize: "14px",
    "& th": {
      textAlign: "left",
      padding: "10px 12px",
      color: "#7E8184",
      fontWeight: 500,
      whiteSpace: "nowrap",
      borderBottom: "1px solid #E4E6EB",
    },
    "& td": {
      padding: "10px 12px",
      borderBottom: "1px solid #F0F1F4",
      whiteSpace: "nowrap",
    },
  },
  bidderName: { fontWeight: 600 },
  bidderEmail: { color: "#7E8184", fontSize: "12px" },
}));

export default useStyles;
